import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { redirectUnauthorizedTo, redirectLoggedInTo, canActivate } from '@angular/fire/compat/auth-guard';
import { NewVersionAvailableComponent } from './pages/new-version-available/new-version-available.component';
import { AppTokenValidationGuard } from './guards/app-token-validation.guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToLayout = () => redirectLoggedInTo(['']);

const fireAuthGuardConfig = canActivate(redirectUnauthorizedToLogin);

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/layout/layout.module').then(m => m.LayoutModule),
    ...fireAuthGuardConfig,
    canActivate: [...(fireAuthGuardConfig.canActivate || []), AppTokenValidationGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/authentication/login/login.component').then(m => m.LoginComponent),
    ...canActivate(redirectLoggedInToLayout)
  },
  {
    // Etiqueta pública al escanear QR de vianda (sin login).
    path: 'v/:id',
    loadComponent: () =>
      import('./pages/vianda-etiqueta-qr/vianda-etiqueta-qr-page.component').then(
        (m) => m.ViandaEtiquetaQrPageComponent
      )
  },
  {
    // Compatibilidad con las etiquetas que ya contienen el detalle en la URL.
    path: 'vianda-etiqueta',
    loadComponent: () =>
      import('./pages/vianda-etiqueta-qr/vianda-etiqueta-qr-page.component').then(
        (m) => m.ViandaEtiquetaQrPageComponent
      )
  },
  {
    path: 'new-version',
    loadComponent: () => import('./pages/new-version-available/new-version-available.component').then(m => m.NewVersionAvailableComponent)
  },
  {
    path: 'external-user',
    loadComponent: () => import('./pages/external-user/external-user.component').then(m => m.ExternalUserComponent)
  },
  {
    // Living catalog of the React design system (every @butaco/react primitive +
    // design tokens). Dev/reference only; reachable by URL. See docs/08-frontend/.
    // Uses the generic ReactHost (route data.reactComponent), like the menús routes.
    path: 'design-system',
    loadComponent: () => import('./react/bridge/react-host.component').then(m => m.ReactHost),
    data: { reactComponent: () => import('./react/features/design-system/DesignSystemCatalog').then(m => m.DesignSystemCatalog) }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
